var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-template-content",domProps:{"innerHTML":_vm._s(_vm.blockContent.replace(/https:\/\/parkos/g, `https://${_vm.$paths.urlEnvPrefix}parkos`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }